module.exports = __webpack_public_path__ + "img/project_e12.23502d14.png";